<template>
  <v-card>
    <v-card class="deduction_height">
      <v-card-text class="pa-2">
        <v-row align="center" justify="space-between" class="mt-0 mr-0 ml-0">
          <h3>评分参考</h3>
          <div>
            <v-tooltip
              v-if="showEditPanel && user.role === 'centreadmin'"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  dark
                  color="pink"
                  class="pa-1"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="changeType"
                >
                  <v-icon>mdi-swap-horizontal</v-icon>
                </v-btn>
              </template>
              <span>修改评分类型</span>
            </v-tooltip>
            <v-tooltip
              v-if="
                showEditPanel &&
                  (user.role === 'centreadmin' ||
                    user.role === 'teacher' ||
                    (user.role === 'assistant' &&
                      config.assistantOperateCheckItem &&
                      (config.enableEditingPublic ||
                        config.enableEditingPrivate)))
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  dark
                  color="pink"
                  class="ml-1"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="create"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>添加评分</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  color="warning"
                  class="ml-1"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="toogleEditPanel"
                >
                  <v-icon>mdi-account-cog</v-icon>
                </v-btn>
              </template>
              <span>显示操作面板</span>
            </v-tooltip>
          </div>
        </v-row>
      </v-card-text>
      <v-card-text class="pa-2 pt-0">
        <v-chip-group
          v-model="selectedType"
          column
          active-class="primary--text"
        >
          <v-chip
            v-for="(type, index) in deductionTypes"
            :key="`type-${index}`"
            :value="type"
            small
          >
            {{ type }}
          </v-chip>
        </v-chip-group>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text class="pa-0">
        <v-list
          v-scroll
          v-bar="{
            preventParentScroll: true,
            scrollThrottle: 30
          }"
          :style="deduction_height"
          class="deduction-list"
        >
          <v-list-item-group v-model="item">
            <template v-for="(item, index) in deductionItems">
              <v-list-item
                :key="`d-${index}`"
                @click="selected(item)"
                dense
                active-class="blue-grey lighten-4"
                exact-active-class="red"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-subtitle
                    class="black--text"
                    style="white-space: normal"
                  >
                    <span v-if="item.hide_comment"
                      ><del
                        >NO.{{ item.display_order }}: {{ item.comment }}</del
                      ></span
                    >
                    <span v-else
                      >NO.{{ item.display_order }}: {{ item.comment }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-action-text
                    class="pt-1 primary--text"
                    style="font-size: 0.9rem"
                  >
                    {{ item.tip }}
                  </v-list-item-action-text>
                  <v-list-item-action-text
                    v-if="item.check_mark === 'error'"
                    class="pt-1"
                  >
                    <v-chip
                      v-if="item.hide_score"
                      class="pa-2 mr-1"
                      color="red"
                      x-small
                    ></v-chip>
                    <v-btn-toggle
                      v-model="item.score"
                      class="d-inline mt-1"
                      mandatory
                    >
                      <v-btn
                        v-for="(score, index) in item.scores"
                        :key="index"
                        :value="score"
                        active-class="red white--text"
                        style="color: rgba(0, 0, 0, 1)"
                        x-small
                      >
                        {{ score }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-list-item-action-text>
                  <v-list-item-action-text
                    v-else-if="item.check_mark === 'right'"
                    class="pt-1"
                  >
                    <v-chip
                      v-if="item.hide_score"
                      class="pa-2 mr-1"
                      color="green"
                      x-small
                    ></v-chip>
                    <v-btn-toggle
                      v-model="item.score"
                      class="d-inline mt-1"
                      mandatory
                    >
                      <v-btn
                        v-for="(score, index) in item.scores"
                        :key="index"
                        :value="score"
                        active-class="green white--text"
                        style="color: rgba(0, 0, 0, 1)"
                        x-small
                      >
                        {{ score }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-list-item-action-text>
                  <v-list-item-action-text v-else class="pt-1">
                    <v-chip
                      v-if="item.hide_score"
                      class="pa-2 mr-1"
                      color="orange"
                      x-small
                    ></v-chip>
                    <v-btn-toggle
                      v-model="item.score"
                      class="d-inline mt-1"
                      mandatory
                    >
                      <v-btn
                        v-for="(score, index) in item.scores"
                        :key="index"
                        :value="score"
                        active-class="orange white--text"
                        style="color: rgba(0, 0, 0, 1)"
                        x-small
                      >
                        {{ score }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-list-item-action-text>
                </v-list-item-content>
                <v-list-item-action v-if="showEditPanel" class="justify-start">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="item.users && 
                          (user.role !== 'assistant' &&
                            user.id !== item.users.id) ||
                            (user.role === 'assistant' &&
                              elective.schedules &&
                              elective.schedules.teacher_id !== item.users.id)
                        "
                        fab
                        x-small
                        icon
                        color="primary"
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-account-box</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item.users ? item.users.name : '' }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="item.users &&
                          (user.role !== 'assistant' &&
                            user.id === item.users.id) ||
                            (user.role === 'assistant' &&
                              elective.schedules &&
                              elective.schedules.teacher_id === item.users.id)
                        "
                        fab
                        x-small
                        icon
                        :color="
                          item.pub_status.dictkey === 'public'
                            ? 'primary'
                            : item.pub_status.dictkey === 'private'
                            ? 'secondary'
                            : 'warning'
                        "
                        class="ma-1"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon v-if="item.pub_status.dictkey === 'public'">
                          mdi-account-group
                        </v-icon>
                        <v-icon
                          v-else-if="item.pub_status.dictkey === 'private'"
                        >
                          mdi-account
                        </v-icon>
                        <v-icon v-else>mdi-account-switch</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item.pub_status.dictvalue }}</span>
                  </v-tooltip>
                  <!-- 管理系统 -> 教学中心 -> 基础数据 -> 参数设置 -> 批改设置 -->
                  <!-- 允许公开私有参考项和私有参考项编辑开启，公有参考项编辑未开启时 -->
                  <!-- 教师可以分享私有参考项 -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                        item.users &&
                          user.id === item.users.id &&
                            item.pub_status.dictkey === 'private' &&
                            config.enableSubmitPrivate &&
                            config.enableEditingPrivate &&
                            !config.enableEditingPublic
                        "
                        fab
                        x-small
                        color="success"
                        class="ma-1"
                        @click.stop="submit(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-playlist-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>分享</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                        item.users &&
                          user.id === item.users.id &&
                            item.pub_status.dictkey === 'preview'
                        "
                        fab
                        x-small
                        color="error"
                        class="ma-1"
                        @click.stop="submitback(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-playlist-minus</v-icon>
                      </v-btn>
                    </template>
                    <span>取消分享</span>
                  </v-tooltip>
                  <!-- 中心管理员通过或退回教师提交的参考项 -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          user.role === 'centreadmin' &&
                            item.pub_status.dictkey === 'preview'
                        "
                        fab
                        x-small
                        color="success"
                        class="ma-1"
                        @click.stop="submitChecked(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-playlist-minus</v-icon>
                      </v-btn>
                    </template>
                    <span>通过</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          user.role === 'centreadmin' &&
                            (item.pub_status.dictkey === 'preview' ||
                              (user.id !== item.users.id &&
                                config.enableSubmitPrivate &&
                                config.enableEditingPrivate &&
                                !config.enableEditingPublic))
                        "
                        fab
                        x-small
                        color="error"
                        class="ma-1"
                        @click.stop="submitbackAdmin(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-playlist-minus</v-icon>
                      </v-btn>
                    </template>
                    <span>退回</span>
                  </v-tooltip>
                  <!-- 中心管理员可以编辑公有参考项 -->
                  <!-- 私有参考项编辑开启时，教师可编辑自己的私有参考项 -->
                  <!-- 公有参考项编辑开启时，教师可编辑自己的公有参考项 -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          (user.role === 'centreadmin' &&
                            item.pub_status.dictkey === 'public') ||
                            (item.users && user.id === item.users.id &&
                              ((item.pub_status.dictkey === 'private' &&
                                config.enableEditingPrivate) ||
                                (item.pub_status.dictkey === 'public' &&
                                  config.enableEditingPublic)))
                        "
                        fab
                        x-small
                        color="warning"
                        class="ma-1"
                        @click.stop="modify(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>修改</span>
                  </v-tooltip>
                  <!-- 中心管理员可以删除公有参考项 -->
                  <!-- 私有参考项编辑开启时，教师可删除自己的私有参考项 -->
                  <!-- 公有参考项编辑开启时，教师可删除自己的公有参考项 -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          (user.role === 'centreadmin' &&
                            item.pub_status.dictkey === 'public') ||
                            (item.users && user.id === item.users.id &&
                              ((item.pub_status.dictkey === 'private' &&
                                config.enableEditingPrivate) ||
                                (item.pub_status.dictkey === 'public' &&
                                  config.enableEditingPublic)))
                        "
                        fab
                        x-small
                        color="error"
                        class="ma-1"
                        @click.stop="remove(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>删除</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="index"></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      selectedType: '',
      lessonId: '',
      deductionItems: [],
      deduction_height: ''
    };
  },
  computed: {
    ...mapGetters([
      'config',
      'user',
      'elective',
      'experiment',
      'deductionTypes',
      'deductions',
      'showEditPanel',
      'selectedItem',
      'hangingDrawdeduction'
    ]),
    item: {
      get() {
        return this.selectedItem;
      },
      set(val) {
        this.changeSelectedItem(val);
      }
    }
  },
  watch: {
    deductionTypes(types) {
      if (types && types.length > 0) {
        let existed = this.deductions.some(item => {
          return item[0] === this.selectedType;
        });

        this.selectedType = existed ? this.selectedType : types[0];
        this.filterDeduction(this.selectedType);
      } else {
        this.deductionItems = [];
      }
    },
    selectedType(type) {
      this.filterDeduction(type);
    }
  },
  methods: {
    ...mapActions([
      'toogleEditPanel',
      'fetchDeductions',
      'showDeductionForm',
      'showDeductionTypeForm',
      'deleteDeduction',
      'submitDeduction',
      'submitBackDeduction',
      'submitBackDeductionAdmin',
      'submitCheckedDeduction',
      'hangupDrawDeduction',
      'alert',
      'changeSelectedItem'
    ]),
    selected(deduction) {
      this.hangupDrawDeduction(deduction);
    },
    filterDeduction(type) {
      let items = [];

      if (type) {
        items = this.deductions.find(item => {
          return item[0] === type;
        })[1];
      } else {
        items = [];
        this.deductions.forEach(item => {
          items.push(...item[1]);
        });
      }

      this.deductionItems = items.sort((a, b) => {
        return parseInt(a.display_order) - parseInt(b.display_order);
      });

      if (this.hangingDrawdeduction) {
        const itemIndex = this.deductionItems.findIndex(item => {
          return item.id === this.hangingDrawdeduction.id;
        });

        if (itemIndex !== -1) this.changeSelectedItem(itemIndex);
        else this.changeSelectedItem(null);
      }
    },
    format(val) {
      if (val) {
        return val.replace(/\n/g, '<br>');
      }
      return val;
    },
    create() {
      this.showDeductionForm(null);
    },
    changeType() {
      this.showDeductionTypeForm();
    },
    submit(item) {
      this.submitDeduction(item.id);
    },
    submitback(item) {
      this.submitBackDeduction(item.id);
    },
    submitbackAdmin(item) {
      this.submitBackDeductionAdmin(item.id);
    },
    submitChecked(item) {
      this.submitCheckedDeduction(item.id);
    },
    modify(item) {
      this.showDeductionForm({
        id: item.id,
        mark: item.check_mark,
        pub_status: item.pub_status.dictkey,
        description: item.comment,
        hide_comment: item.hide_comment,
        notes: item.tip,
        scores: item.scores,
        hide_score: item.hide_score,
        order: item.display_order,
        type: item.type,
        type_order: item.type_order,
        experiment: item.experiment,
        isCommon: item.is_common,
        creater: item.users ? item.users.name : '',
        color: item.color
          ? item.color
          : item.check_mark === 'right'
          ? '#008B00'
          : '#FF0000'
      });
    },
    remove(deduction) {
      if (deduction.users &&
        this.user.role === 'centreadmin' ||
        this.user.name === deduction.users.name
      ) {
        this.$store.commit('setConfirmAction', async () => {
          await this.deleteDeduction(deduction.id);
          this.$store.commit('setConfirm', '');
        });
        this.$store.commit('setConfirm', '您确定删除该标签吗？');
      } else {
        this.alert({ message: '该标签只能由创建者删除', color: 'error' });
      }
    },
    observerDeductionHeight() {
      const deductionHeight = document.querySelector('.deduction_height');
      const deductionHeightObserver = new ResizeObserver(([entry]) => {
        const h = entry.contentRect.height;
        this.deduction_height = 'height: calc(100vh - '.concat(h, 'px);');
      });
      deductionHeightObserver.observe(deductionHeight);
    }
  },
  mounted() {
    this.selectedType = this.deductionTypes[0] || '';
    this.observerDeductionHeight();
  }
};
</script>
